import { LectioJSUtils } from '../LectioJSUtils';
import { AspNetCustomValidatorArgument } from '../LectioValidator';

export interface LCCommentBlockCommandArguments {
	omitFocus?: boolean;
}
export interface LCCommentBlockSalvagedState {
	commentBlockHtml: string;
}

export namespace LCCommentBlockUtility {
	export function FindCommentBlocks(container: CKEDITOR.dom.element): CKEDITOR.dom.nodeList {
		return container.find('section.lc-display-commentblock');
	}

	export function SalvageState(editor: CKEDITOR.editor): LCCommentBlockSalvagedState {
		const cbs1 = LCCommentBlockUtility.FindCommentBlocks(editor.editable()!);
		let commentBlockHtml = '';
		if (cbs1.count() !== 0) {
			const section = cbs1.getItem(0) as CKEDITOR.dom.element;
			commentBlockHtml = section.findOne('.lc-display-commentblock-contents').getHtml();
		}

		return {
			commentBlockHtml: commentBlockHtml,
		};
	}

	export function RestoreSalvagedState(state: LCCommentBlockSalvagedState, editor: CKEDITOR.editor): void {
		if (state.commentBlockHtml) {
			const args: LCCommentBlockCommandArguments = { omitFocus: true };
			editor.execCommand('lectiocommentblock', args);
			const cbs2 = LCCommentBlockUtility.FindCommentBlocks(editor.editable()!);
			if (cbs2.count() !== 0) {
				const section = cbs2.getItem(0) as CKEDITOR.dom.element;
				section.findOne('.lc-display-commentblock-contents').setHtml(state.commentBlockHtml);
			}
		}
	}

	export function GetEditorForValidator(val: Element): CKEDITOR.editor {
		const ta = $(val).parent().find('textarea')[0];
		LectioJSUtils.AssertNotNullOrUndefined(ta, 'ta');

		const editor = CKEDITOR.instances[ta.id as any];
		LectioJSUtils.AssertNotNullOrUndefined(editor, 'editor');

		return editor!;
	}

	export function CustomValidator_LCDocumentEditorCommentBlock_Validate(val: Element, args: AspNetCustomValidatorArgument): void {
		const editor = LCCommentBlockUtility.GetEditorForValidator(val);

		const maxlengths = val.getAttribute('maxlength');
		if (!maxlengths) {
			args.IsValid = true;
			return;
		}
		const maxlength = parseInt(maxlengths, 10);

		const cbs = LCCommentBlockUtility.FindCommentBlocks(editor.editable()!);
		let isvalid: boolean;
		if (cbs.count() !== 0) {
			const el = cbs.getItem(0) as CKEDITOR.dom.element;
			isvalid = el.getText().length <= maxlength;

			const math = el.find("SPAN.lc-math-tex");
			isvalid = isvalid && (!!math);
		}
		else
			isvalid = true;

		args.IsValid = isvalid;
	}

	export function CustomValidator_LCDocumentEditorCommentBlock_UpdateDisplay(val: Element & { isvalid?: boolean }): void {
		const editor = LCCommentBlockUtility.GetEditorForValidator(val);
		const cbs = LCCommentBlockUtility.FindCommentBlocks(editor.editable()!);

		if (cbs.count() === 0)
			return;

		const e = cbs.getItem(0) as CKEDITOR.dom.element;

		const list = e.findOne('.lc-display-commentblock-errormessage');
		if (!list)
			return;
		const errcontainer = list;
		errcontainer.setStyle('display', val.isvalid ? '' : 'inherit');
		let msg = '';
		if (!val.isvalid) {
			const maxlengths = parseInt(val.getAttribute('maxlength') as string, 10);
			msg = 'Enten er teksten er for lang (må maksimalt være ' + maxlengths + ' tegn) eller der er formler i noten.';
		}

		errcontainer.setText(msg);
	}
}
